import React from 'react';
import RestCreate from 'containers/rest/Create';
import Form from '../components/Form';
import { banCustomer } from '@redux/bannedCustomers/actions';

const breadcrumbs = [
  {
    title: 'common.page.customerBlacklist',
    href: '/settings/bannedCustomers',
  },
  {
    title: 'common.page.create',
  },
];
const CustomersCreate = () => {
  return (
    <RestCreate
      model="bannedCustomers"
      breadcrumbs={breadcrumbs}
      hasSelectFilter={false}
      customApiSubmit={banCustomer}
      customPathAfterSubmit="settings/bannedCustomers"
    >
      <Form />
    </RestCreate>
  );
};

export default CustomersCreate;
